import { useApp } from '../context/AppContext';

const TYPE_CONFIG = {
  success: { icon: '✅', color: '#1a7a4a', bg: '#f0faf4', border: '#a3d9b8' },
  error:   { icon: '❌', color: '#b91c1c', bg: '#fef2f2', border: '#fca5a5' },
  warning: { icon: '⚠️', color: '#92400e', bg: '#fffbeb', border: '#fcd34d' },
  info:    { icon: 'ℹ️', color: '#1e40af', bg: '#eff6ff', border: '#93c5fd' },
  default: { icon: '🔔', color: '#1e293b', bg: '#f8fafc', border: '#cbd5e1' },
};

export default function Toast() {
  const { toast } = useApp();
  const cfg = TYPE_CONFIG[toast.type] || TYPE_CONFIG.default;

  return (
    <div style={{
      position: 'fixed',
      top: 16,
      left: '50%',
      transform: `translateX(-50%) translateY(${toast.show ? '0' : '-80px'})`,
      opacity: toast.show ? 1 : 0,
      transition: 'transform 0.22s cubic-bezier(.4,0,.2,1), opacity 0.22s',
      zIndex: 9999,
      pointerEvents: toast.show ? 'auto' : 'none',
      minWidth: 280,
      maxWidth: 480,
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '11px 16px',
        background: cfg.bg,
        border: `1.5px solid ${cfg.border}`,
        borderRadius: 10,
        boxShadow: '0 4px 24px rgba(0,0,0,0.13)',
        color: cfg.color,
        fontSize: 13,
        fontWeight: 500,
        whiteSpace: 'nowrap',
      }}>
        <span style={{ fontSize: 16, flexShrink: 0 }}>{cfg.icon}</span>
        <span style={{ flex: 1, whiteSpace: 'normal', lineHeight: 1.4 }}>{toast.msg}</span>
      </div>
    </div>
  );
}
